/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import axios from "axios";
import { WarningMessage } from '../Utils.js';


export const AxiosSetstorageStructure = async (file) => {
    if (file.includes('structures')) {

        try {
            await axios({
                method: "get",
                url: "/api/structure/?by_file=" + file,
                responseType: 'json',
            }).then(
                function (response) {
                    var structurestorage = JSON.parse(sessionStorage.getItem('structures'));
                    var filename = file.substring(file.lastIndexOf('/') + 1);
                    if (!structurestorage.hasOwnProperty(filename)) {
                        structurestorage[filename] = { 'id': response.data.id, 'trajectories': {} };
                    }
                    sessionStorage.setItem('structures', JSON.stringify(structurestorage));
                }
            );
        } catch (error) {
            WarningMessage(error)
        }
    } else if (file.includes('trajectories')) {
        try {
            await axios({
                method: "get",
                url: "/api/trajectory/?by_file=" + file,
                responseType: 'json',
            }).then(
                function (response) {
                    var structurestorage = JSON.parse(sessionStorage.getItem('structures'));
                    var filenametraj = file.substring(file.lastIndexOf('/') + 1);
                    var id_structure = response.data.structure;
                    for (let [filename, values] of Object.entries(structurestorage)) {
                        if (values['id'] === id_structure) {
                            var filenamestr = filename
                        }
                    }
                    structurestorage[filenamestr]['trajectories'][filenametraj] = { 'id': response.data.id };
                    sessionStorage.setItem('structures', JSON.stringify(structurestorage));
                }
            );
        } catch (error) {
            WarningMessage(error)
        }
    }
};